import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import Events from '../hooks/events';

const DatasetNotificationSendAction = ({ code, name, disabled }) => {
  const datasetNotification = Events.useShowDatasetNotificationCreate({ code });
  return (
    <RibbonMenu
      name="notify"
      icon="send"
      message="actions.notify"
      className="aridhia-dataset-notification-send-action"
      onClick={() => datasetNotification({ name })}
      disabled={disabled}
    />
  );
};

export default DatasetNotificationSendAction;
